export const organizationsPathPatterns = {
  list: "/customers/:customerId/organizations",
} as const;
